import { useNavigate } from "react-router-dom";
import { parseAPIErrorResponse } from "melco-shared-logic";
import { useLogin } from "../../hooks/login/useLogin";
import { useEffect, useState } from "react";
import { DisplayErrors } from "../helper/DisplayErrors";
import LoadingDefaultSpinIndicator from "../loading/LoadingDefaultSpinIndicator";
export type DirectLoginWithoutPasswordValueType = {
  password: string;
};

type DirectLoginWithoutPasswordProps = {
  view_id: string | undefined;
  access_token: string | null;
  user_id: number | undefined;
};

export const DirectLoginWithoutPassword: React.FC<
  DirectLoginWithoutPasswordProps
> = ({ view_id, access_token, user_id }) => {
  const navigate = useNavigate();
  const login = useLogin();
  const [errors, setErrors] = useState<any[]>();
  const [loading, setLoading] = useState<boolean>(true);

  const onSubmit = async () => {
    try {
      setLoading(true);
      const loginResponse = await login({
        password: "",
        view_id,
        access_token,
      });
      if (loginResponse) {
        navigate("/view", {
          state: {
            password: "",
            view_id,
            access_token,
            apiResponse: loginResponse,
            user_id: user_id,
          },
        });
      }
    } catch (error) {
      const apiErrors = await parseAPIErrorResponse(error);

      setErrors(apiErrors);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // Use useEffect to trigger onSubmit when the component is mounted
  useEffect(() => {
    onSubmit();
  }, []); // Dependency array ensures this runs only once

  return (
    <>
      {errors && errors.length > 0 && <DisplayErrors errors={errors} />}
      <LoadingDefaultSpinIndicator
        isShown={loading}
      ></LoadingDefaultSpinIndicator>
    </>
  );
};
